<template>
  <div>
    <div 
      v-if="isReportEnabled('registrationViewTheReport')" 
      :class="['reportCard', classes.registration]" 
      @click="prepateRegistrations()" 
      data-report="eventSelfReg"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.registration-costs") }}</div>
      <div class="cardDesc">{{ $tc("page.report.registration-costs-description") }}</div>
    </div>

    <div 
      v-if="isReportEnabled('scoringCostsViewTheReport')" 
      :class="['reportCard', classes.scoring]" 
      @click="scoring()" 
      data-report="eventSelfReg"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.scoring-costs") }}</div>
      <div class="cardDesc">{{ $tc("page.report.scoring-costs-description") }}</div>
    </div>

    <div 
      v-if="isReportEnabled('spectatorCostsViewTheReport')" 
      :class="['reportCard', classes.spectator]" 
      @click="spectator()" 
      data-report="eventSelfReg"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.spectator-costs") }}</div>
      <div class="cardDesc">{{ $tc("page.report.spectator-costs-description") }}</div>
    </div>

    <div class="v-spacer"></div>

    <v-text-field v-if="loading" disabled color="success" loading></v-text-field>

    <v-card v-if="displayTable" class="mx-auto" width="100%">
      <v-card-title v-if="classes.registration == 'active'">{{ $tc("page.report.event-costs") }}</v-card-title>
      <v-card-title v-if="classes.scoring == 'active'">{{ $tc("page.report.scoring-costs") }}</v-card-title>
      <v-card-title v-if="classes.spectator == 'active'">{{ $tc("page.report.spectator-report-cost") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete 
                v-if="classes.registration == 'active'" 
                v-model="eventSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
              <v-autocomplete 
                v-if="classes.scoring == 'active'" 
                v-model="eventScoringSelected" 
                :items="eventScoringItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
              <v-autocomplete 
                v-if="classes.spectator == 'active'" 
                v-model="eventSpectatorSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row style="text-align: left" v-if="classes.registration == 'active'">
            <v-col cols="12" sm="12"> 
              <div>{{eventSelected?.id}} :: {{ registration_cost_resume?.name }} - {{ registration_cost_resume?.date }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-registered-participants") }}: {{ registration_cost_resume?.total }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-participant-payments") }}: {{ registration_cost_resume.payments }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-deleted-participants") }}: {{ registration_cost_resume.deleted }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-completed-participants") }}: {{ registration_cost_resume.completed }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-added-participants") }}: {{ registration_cost_resume.added }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-imported-participants") }}: {{ registration_cost_resume.imported }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-inPayment-participants") }}: {{ registration_cost_resume.inPayment }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-unconfirmed-participants") }}: {{ registration_cost_resume.unconfirmed }}</div>
              <div>---------------------------------------------</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-participants-with-number") }}: {{ registration_cost_resume.pwnum }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total-participants-without-number-with-payment") }}: {{ registration_cost_resume.pwonum }}</div>
              <div>{{ $tc("page.report.registration-cost-resume.total") }}: {{ registration_cost_resume.pwtot }}</div>
            </v-col>
          </v-row>
          <v-row style="text-align: left" v-if="classes.scoring == 'active'">
            <v-col cols="12" sm="12">
              <div>{{ scoring_cost_resume?.name }} - {{ scoring_cost_resume?.date }}</div>
              <div>{{ $tc("page.report.scoring-cost-resume.total-participants") }}: {{ scoring_cost_resume?.total }}</div>
              <div>{{ $tc("page.report.scoring-cost-resume.total-deleted-participants") }}: {{ scoring_cost_resume?.deleted }}</div>
              <div>{{ $tc("page.report.scoring-cost-resume.total-imported-participants") }}: {{ scoring_cost_resume?.imported }}</div> 
              <div>{{ $tc("page.report.scoring-cost-resume.total-backup-score") }}: {{ scoring_cost_resume?.backup }}</div>
              <div>{{ $tc("page.report.scoring-cost-resume.total-final-score") }}: {{ scoring_cost_resume?.finalScores }}</div>
            </v-col>
          </v-row>
          <v-row style="text-align: left" v-if="classes.spectator == 'active'">
            <v-col cols="12" sm="12">
              <div>{{ spectator_cost_resume?.name }} - {{ spectator_cost_resume?.date }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total") }}: {{ spectator_cost_resume?.total }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total-cancelled") }}: {{ spectator_cost_resume?.canceled }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total-inpayment") }}: {{ spectator_cost_resume.inPayment }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total-unconfirmed") }}: {{ spectator_cost_resume.unconfirmed }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total-completed") }}: {{ spectator_cost_resume?.completed }}</div>
              <div>{{ $tc("page.report.spectator-cost-resume.total-added") }}: {{ spectator_cost_resume?.added }}</div>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-2 white--text" @click="dowloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-2 white--text" @click="dowloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" v-if="classes.registration == 'active'">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorDataRegistrationCosts" :options="tabulatorOptionsRegistrationCosts" class="table-striped table-bordered table-sm" />
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" v-if="classes.scoring == 'active'">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorDataScoringCosts" :options="tabulatorOptionsScoringCosts" class="table-striped table-bordered table-sm" />
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center" v-if="classes.spectator == 'active'">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator ref="tabulator" v-model="tabulatorDataSpectatorCosts" :options="tabulatorOptionsSpectatorCosts" class="table-striped table-bordered table-sm" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";

export default {
  mixins: [apiCalls],
  data() {
    return {
      eventSelected: {},
      eventScoringSelected: {},
      eventSpectatorSelected: {},
      eventItems: [],
      eventScoringItems: [],
      report: "",
      search: "",
      tabulatorDataRegistrationCosts: [],
      tabulatorDataScoringCosts: [],
      tabulatorDataSpectatorCosts: [],
      FilteredDataEventId: [],
      FilteredSelfRegId: [],
      displayTable: false,
      classes: {
        registration: "",
        scoring: "",
        spectator: ""
      },
      registration_cost_resume: {},
      scoring_cost_resume: {},
      spectator_cost_resume: {},
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig
    }),
    tabulatorOptionsRegistrationCosts() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.registration-costs-table-columns.counter"),
            field: "counter",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.registration-costs-table-columns.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.registration-costs-table-columns.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.registration-costs-table-columns.number"),
            field: "number",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 60,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.registration-costs-table-columns.name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("name", "registration"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.registration-costs-table-columns.tag-id"),
            field: "tagId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
        ],
      };
    }, 
    tabulatorOptionsScoringCosts() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.scoring-costs-table-columns.counter"),
            field: "counter",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.billing-date-used"),
            field: "billingDateUsed",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.displayed-number"),
            field: "displayedNumber",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("name", "scoring"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.scoring-costs-table-columns.number"),
            field: "number",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 60,
            formatter: "textarea"
          },
        ],
      };
    }, 
    tabulatorOptionsSpectatorCosts() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 400,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.spectator-costs-table-columns.first-name"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.spectator-costs-table-columns.last-name"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.spectator-costs-table-columns.date-birth"),
            field: "dateBirth",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.spectator-costs-table-columns.registered-by"),
            field: "regByName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.spectator-costs-table-columns.status"),
            field: "status",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("status", "spectator"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.spectator-costs-table-columns.created-date"),
            field: "created_at",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ],
      };
    },
    isShowButtons() {
      return (
        (this.report == 'registration' && this.tabulatorDataRegistrationCosts.length > 0) ||
        (this.report == 'scoring' && this.tabulatorDataScoringCosts.length > 0) ||
        (this.report == 'spectator' && this.tabulatorDataSpectatorCosts.length > 0)
      );
    }
  },
  methods: {
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, source = "registration") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
          if (!selectedValues.length) return true;
          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const sourceMap = {
              registration: this.tabulatorDataRegistrationCosts,
              scoring: this.tabulatorDataScoringCosts,
              spectator: this.tabulatorDataSpectatorCosts,
            };
            const tableData = sourceMap[source] || [];
            const unique = new Set();
            tableData.forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });
            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    refresh() {
      if (this.report == "registration") {
        this.registrations({
          eventId: this.eventSelected?.id,
        });
      } else if(this.report == "scoring") {
        this.scoring({
          eventId: this.eventScoringSelected?.id
        },true);
      } else {
        this.spectator({
          eventId: this.eventSpectatorSelected?.id
        },true);
      }
    },
    removeClasses() {
      this.classes.registration = "";
      this.classes.scoring = "";
    },
    async prepateRegistrations(filter = null) {
      this.classes.scoring = "";
      this.classes.spectator = "";

      if(this.classes.registration == "active"){
        this.classes.registration = "";
        this.displayTable = false;
      } else {
        this.classes.registration = "active";
        this.displayTable = true;
      }
      this.report = "registration";

      let data = {};

      if (filter != null) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/costs/registration", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });
      
    },
    async registrations(filter = null) {

      this.classes.scoring = "";
      this.classes.spectator = "";
      this.classes.registration = "active";
      this.displayTable = true;

      this.report = "registration";

      let data = {};
      const isEmptyFilter = !filter || 
                            filter == null ||
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));

      if (!isEmptyFilter) {
        data.filter = filter;
      } else {
        this.tabulatorDataRegistrationCosts = [];
        this.registration_cost_resume = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/costs/registration", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      if(this.eventSelected?.id) {
      //the table data
      this.tabulatorDataRegistrationCosts = response.results;
      this.registration_cost_resume = response.registration_cost_resume;
      } 
    },
    async scoring(filter = null, isShowReport = false) {
      this.classes.scoring = "active";
      this.displayTable = true;
      this.classes.spectator = "";
      this.classes.registration = "";

      this.report = "scoring";

      let data = {};
      const isEmptyFilter = !filter || 
                            filter == null ||
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));

      if (!isEmptyFilter) {
        data.filter = filter;
      } else if(isShowReport) {
        this.tabulatorDataScoringCosts = [];
        this.scoring_cost_resume = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }
      const response = await this.api("post", "/api/v1/promoter/reports/events/costs/scoring", data);

      //select for events
      this.eventScoringItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      if(isShowReport) {
        if(this.eventScoringSelected?.id) {
          this.tabulatorDataScoringCosts = response.results;
          this.scoring_cost_resume = response.scoring_cost_resume;
        } else {
          this.tabulatorDataScoringCosts = [];
          this.scoring_cost_resume = [];
          this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
          this.$store.commit('reports/SET_SHOW_ALERT', true);
        }
      }

    },
    async spectator(filter = null, isShowReport = false) {
      this.classes.scoring = "";
      this.displayTable = true;
      this.classes.spectator = "active";
      this.classes.registration = "";

      this.report = "spectator";

      let id = 0;
      const isEmptyFilter = !filter || 
                            filter == null ||
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));

      if (!isEmptyFilter) {
        id = filter.eventId;
      } else if(isShowReport) {
        this.tabulatorDataSpectatorCosts = [];
        this.spectator_cost_resume = [];
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-event-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      let response = await this.api("get", "/api/v1/promoter/reports/events/spectator/" + id);

      this.eventItems = response.filters[0]?.filter?.data?.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });
      
      if(this.eventSpectatorSelected?.id && isShowReport) {
        this.tabulatorDataSpectatorCosts = response.results.map((el) => {
          return {
            ...el,
            regByName: `${el.regByFirstName} ${el.regByLastName}`
          }
        });
        this.spectator_cost_resume = response.spectator_cost_resume;
      }
    },
    dowloadAsPDF() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.downloadToTab("pdf");
    },
    dowloadAsCSV() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.download("csv", "data.csv", {
        delimiter: ",",
      });
    },
    isReportEnabled(reportId) {
      return this.reportConfig.registrationCosts.reports.find(report => report.name === reportId && report.isEnabled) || false;
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
